import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

const LS_INFO_VISIBLE = 'sc-pref:infoDialog:visible'
const LS_INFO_COLLAPSED = 'sc-pref:infoDialog:defaultCollapsed'
const LS_DEV_CONSOLE = 'sc-pref:devConsole:visible'

function readBool(key: string, fallback: boolean): boolean {
  const val = localStorage.getItem(key)
  return val === null ? fallback : val === 'true'
}

export const useUserPreferencesStore = defineStore('user-preferences', () => {
  /** Whether the Info Dialog widget is shown on screen */
  const infoDialogVisible = ref(readBool(LS_INFO_VISIBLE, true))

  /** Whether the Info Dialog starts collapsed (true) or expanded (false) */
  const infoDialogDefaultCollapsed = ref(readBool(LS_INFO_COLLAPSED, true))

  /** Whether the Dev Console is visible (defaults to off until user enables it) */
  const devConsoleVisible = ref(readBool(LS_DEV_CONSOLE, false))

  watch(infoDialogVisible, v => {
    localStorage.setItem(LS_INFO_VISIBLE, String(v))
  })

  watch(infoDialogDefaultCollapsed, v => {
    localStorage.setItem(LS_INFO_COLLAPSED, String(v))
  })

  watch(devConsoleVisible, v => {
    localStorage.setItem(LS_DEV_CONSOLE, String(v))
  })

  return { infoDialogVisible, infoDialogDefaultCollapsed, devConsoleVisible }
})
